templateTextBuilderFactory.$inject = [];


/**
* @ngdoc    object
* @module   csm.text
* @name     csm.text.type:TemplateTextBuilder
* 
* @constructor
* @param {string}  template  Template text.
* @param {object=} values    Field values.
*
* @description
* Builds strings from templates with embedded fields. Fields are designated
* within a string template as `{fieldName}`. Embedded braces are represented in 
* the template as double braces, `{{` and `}}`, are replaced with single braces.
* @example
  <example module="TemplateTextBuilderExample">
    <file name="index.html">
      <div ng-controller="TemplateTextBuilderController">
        <form novalidate class="simple-form">
          <label>template:</label> <input type="string" ng-model="template" style="width: 500px" /><br />
          <label>value1:</label>   <input type="string" ng-model="value1" /><br />
          <label>value2:</label>   <input type="string" ng-model="value2" />
          <button ng-click='showResult()'>Test</button>
        </form>
        <div><pre>{{result}}</pre></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('TemplateTextBuilderExample', [ 'csm.text' ])
      .controller("TemplateTextBuilderController", function ($scope, TemplateTextBuilder) 
        {
        $scope.template   = 'Been around now for {value1} years. Hope to be around for {value2} more!';
        $scope.value1     = 100;
        $scope.value2     = 200;
        $scope.showResult = function() 
          { 
          var template = new TemplateTextBuilder($scope.template);
          template['value1'] = $scope.value1;
          template['value2'] = $scope.value2;
          $scope.result      = template.toString();
          };
        });
    </file>
  </example>
**/
/* @ngInject */ export function templateTextBuilderFactory() {
  function TemplateTextBuilder(template, values) {
    this.__template = template;
    for (var p in values) this[p] = values[p];
  }

  TemplateTextBuilder.prototype = {
    /***************************************************************************
     * clear */
    /**
     * @ngdoc    function
     * @name     clear
     * @methodOf csm.text.type:TemplateTextBuilder
     *
     * @description
     * Clears all field values.
     ***************************************************************************/
    clear: function () {
      for (var p in this)
        if (this.hasOwnProperty(p) && p != '__template') delete this[p];
    },

    /***************************************************************************
     * toString */
    /**
     * @ngdoc    function
     * @name     toString
     * @methodOf csm.text.type:TemplateTextBuilder
     *
     * @description
     * Returns template text with all fields replaced with field values and
     * double braces replaced with single braces. Fields with no values will be
     * filled with spaces.
     ***************************************************************************/
    toString: function () {
      var values = this;

      return this.__template
        .replace(/({*){(\w+)}(}*)/g, function (match, lb, name, rb) {
          return lb.length % 2 || rb.length % 2
            ? match
            : lb + (values[name] !== undefined ? values[name] : '') + rb;
        })
        .replace('{{', '{')
        .replace('}}', '}');
    }
  };

  return TemplateTextBuilder;
}
